const firebaseConfig = {
  apiKey: "AIzaSyA-P9Xo4ZhK0JV-QxPzP2_iUeN9YV4XrXQ",
  authDomain: "cycle-wala-99d26.firebaseapp.com",
  projectId: "cycle-wala-99d26",
  storageBucket: "cycle-wala-99d26.appspot.com",
  messagingSenderId: "230440739507",
  appId: "1:230440739507:web:402c533432db5e553d46c6"
};

export default firebaseConfig;